module.exports = __webpack_public_path__ + "assets/img/9288-gu.svg";